import { useTranslation } from "react-i18next";
import { Col, Form, MenuProps, Row, Spin, Switch, Typography } from "antd";
import { FormInstance } from "antd/lib";
import { FunctionComponent } from "react";
import FormInput from "../../../../../components/form-input/FormInput";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";
import { get, isEmpty } from "lodash";
import { regexEmailV2, phoneNumberRegex, regexEmail } from "../../../../../utils/regex";



type FormCreateLecturerProps = {
	form: FormInstance,
	onFinish?: any,
	dataOptions?: any,
	loadingForm: boolean,
}



const FormCreateLecturer: FunctionComponent<FormCreateLecturerProps> = ({ form, onFinish, dataOptions, loadingForm }) => {
  const { t } = useTranslation();

  const validations = {
	name: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (value && value.length > 512) {
				return Promise.reject(new Error(t("Tên người dùng không vượt quá 512 ký tự", "Tên người dùng không vượt quá 512 ký tự")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập tên người dùng", "Vui lòng nhập tên người dùng")))
			}
			return Promise.resolve()
		}
	},
	organization: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng chọn đơn vị", "Vui lòng chọn đơn vị")))
			}
			return Promise.resolve()
		}
	},
	gender: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng chọn giới tính", "Vui lòng chọn giới tính")))
			}
			return Promise.resolve()
		}
	},
	phone: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!isEmpty(value) && !value.match(new RegExp(phoneNumberRegex))) {
				return Promise.reject(new Error(t("Sai định dạng, vui lòng nhập lại", "Sai định dạng, vui lòng nhập lại")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập số điện thoại", "Vui lòng nhập số điện thoại")))
			}
			return Promise.resolve()
		}
	},
	email: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!isEmpty(value) && !value.match(new RegExp(regexEmail))) {
				return Promise.reject(new Error(t("Sai định dạng, vui lòng nhập lại", "Sai định dạng, vui lòng nhập lại")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập địa chỉ email", "Vui lòng nhập địa chỉ email")))
			}
			return Promise.resolve()
		}
	},
}

  const gendersOptions = [
	{
		id: "Nam",
		name: "Nam",
	},
	{
		id: t("Nữ", "Nữ"),
		name: t("Nữ", "Nữ"),
	},
	{
		id: t("Khác", "Khác"),
		name: t("Khác", "Khác"),
	},
];

	return (
		<>
			<Form layout={"vertical"} form={form} onFinish={onFinish} name="createUser" initialValues={{ status: true }}>
				{loadingForm ?
					<div className="statistic-course-content statistic-course-loading">
						<Spin size="large" />
					</div>
					:
					<Row gutter={[16, 16]}>
						<Col span={24}>
							<Form.Item name="name" rules={[validations.name]} label={t("Tên người dùng", "Tên người dùng")}>
								<FormInput placeholder={t("Nhập tên người dùng", "Nhập tên người dùng")} />
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item name="organization" rules={[validations.organization]} label={t("Đơn vị", "Đơn vị")}>
								<FormItemDropdown options={get(dataOptions, 'dataOrganization', '')} allowClear={true} placeholder={t("Chọn đơn vị", "Chọn đơn vị")} />
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item name="regency" label={t("Chức vụ", "Chức vụ")}>
								<FormItemDropdown options={get(dataOptions, 'dataRegency', '')} allowClear={true} placeholder={t("Chọn chức vụ", "Chọn chức vụ")} />
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item name="academicLevel" label={t("Trình độ học vấn", "Trình độ học vấn")}>
								<FormItemDropdown options={get(dataOptions, 'dataAcademicLevel', '')} allowClear={true} placeholder={t("Chọn trình độ học vấn", "Chọn trình độ học vấn")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="gender" rules={[validations.gender]} label={t("Giới tính", "Giới tính")}>
								<FormItemDropdown options={gendersOptions} placeholder={t("Chọn giới tính", "Chọn giới tính")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="domicile" label={t("Nguyên quán", "Nguyên quán")}>
								<FormItemDropdown options={get(dataOptions, 'dataProvince', '')} allowClear={true} placeholder={t("Chọn nguyên quán", "Chọn nguyên quán")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="phone" rules={[validations.phone]} label={t("Điện thoại liên hệ", "Điện thoại liên hệ")}>
								<FormInput placeholder={t("Nhập số điện thoại", "Nhập số điện thoại")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="email" rules={[validations.email]} label={t("Địa chỉ Email", "Địa chỉ Email")}>
								<FormInput placeholder={t("Nhập địa chỉ email", "Nhập địa chỉ email")} />
							</Form.Item>
						</Col>
						<Col span={24} style={{ display: "flex", justifyContent: "space-between" }}>
							<span>{t("Trạng thái", "Trạng thái")}</span>
							<Form.Item name="status">
								<Switch defaultChecked />
							</Form.Item>
						</Col>
					</Row>
				}
			</Form>
		</>
	)
}

export default FormCreateLecturer;